export default __webpack_public_path__ + "static/media/mgtow.5c830c0e.png";